import { Theme } from '@mui/system';
import styled from '@mui/system/styled';

const ImgWrapper = styled('div')(({ theme }: { theme?: Theme }) => ({
  display: 'block',
  height: 'auto',
  verticalAlign: 'middle',
  paddingLeft: '1px',
  '& img': {
    borderRadius: '50%',
    maxWidth: '100%',
    width: '100%',
    height: 'auto'
  },
  '@media (max-width: 320px) ': {
    paddingLeft: '1px'
  },
  [theme.breakpoints.up('sm')]: {
    '& img': {
      padding: '0 8.5px',
      marginTop: '-5px',
      marginLeft: '-4.5px'
    }
  },
  [theme.breakpoints.up('md')]: {
    '& img': {
      padding: '0 1px',
      marginTop: '3px',
      marginLeft: '3px'
    }
  },
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 0,
    '& img': {
      padding: 0,
      paddingLeft: '1px',
      marginTop: '4px',
      marginLeft: '-4px'
    }
  }
}));

export default ImgWrapper;
